module.exports = __webpack_public_path__ + "static/media/levels_1_3.37ed1ea5.svg";